import PropTypes from "prop-types";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import ConfirmDialog from "components/DigiHapi/ConfirmDialog";

/**
 * Deletion confirmation asking the user to type the name of the entity.
 */
export default function DeleteConfirmationDialog({
	open,
	message,
	instruction,
	inputLabel,
	inputId,
	onInputChange,
	onCancel,
	onConfirm
}) {
	return (
		<ConfirmDialog
			open={open}
			message={message}
			confirmText="Supprimer"
			onCancel={onCancel}
			onConfirm={onConfirm}
		>
			<MDTypography variant="button" color="text" component="p" mt={1}>
				{instruction}
			</MDTypography>
			<MDBox mt={2}>
				<MDInput
					label={inputLabel}
					id={inputId}
					fullWidth
					onChange={onInputChange}
				/>
			</MDBox>
		</ConfirmDialog>
	);
}

DeleteConfirmationDialog.propTypes = {
	open: PropTypes.bool,
	message: PropTypes.node,
	instruction: PropTypes.node,
	inputLabel: PropTypes.string,
	inputId: PropTypes.string,
	onInputChange: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired
};
